/** code_detail 페이지 API — total 만큼 전부 조회 (은행 NG11 등) */
export async function fetchCodeDetailList(baseUrl, groupCode, request) {
  const pageSize = 100;
  let pageNo = 1;
  let list = [];
  let total = 0;

  for (;;) {
    const url = `${baseUrl}?groupCode=${encodeURIComponent(groupCode)}&pageSize=${pageSize}&pageNo=${pageNo}&sortOrd=asc`;
    const ret = await request(url);
    const payload = ret?.data?.data;
    const page = Array.isArray(payload?.list) ? payload.list : [];
    if (!page.length) break;

    total = Number(payload.total) || page.length;
    list = list.concat(page);

    if (list.length >= total || page.length < pageSize) break;
    pageNo += 1;
  }

  return list.filter(row => row?.useYn === 'Y' && row?.delYn === 'N');
}
